var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomePageBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 832,
    viewBox: "0 0 1280 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3223)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.403 236.687C133.191 249.098 121.972 258.25 108.596 258.25C92.7266 258.25 79.8299 245.36 79.8299 229.5C79.8299 213.64 92.7267 200.75 108.596 200.75C121.972 200.75 133.239 209.902 136.403 222.312L281 222.312C277.212 130.408 201.51 57 108.596 57C13.2846 57 -64 134.242 -64 229.5C-64 324.758 13.2846 402 108.596 402C201.51 402 277.212 328.64 281 236.687L136.403 236.687Z",
    fill: "#019AE6",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1163.67 158.954C1172.35 168.386 1173.95 182.775 1166.7 194.012C1158.09 207.342 1140.26 211.183 1126.94 202.577C1113.62 193.972 1109.79 176.146 1118.4 162.815C1125.65 151.579 1139.45 147.08 1151.59 151.155L1230.05 29.6901C1150.79 -16.9908 1048.05 6.77356 997.642 84.8237C945.931 164.887 968.885 271.716 1048.9 323.398C1128.92 375.08 1235.74 352.067 1287.45 272.003C1337.86 193.953 1317.31 90.5594 1242.12 37.4893L1163.67 158.954Z",
    fill: "#00A741"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M980.019 639.754C992.356 643.237 1001.26 654.652 1000.97 668.025C1000.62 683.891 987.455 696.503 971.598 696.157C955.741 695.811 943.136 682.636 943.483 666.77C943.775 653.398 953.17 642.333 965.647 639.441L968.803 494.878C876.838 496.659 801.795 570.741 799.767 663.633C797.687 758.922 873.223 837.874 968.459 839.953C1063.69 842.032 1142.6 766.451 1144.68 671.163C1146.71 578.271 1075.02 500.985 983.174 495.192L980.019 639.754Z",
    fill: "#019AE6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M307.139 614.6C300.635 603.553 302.096 589.149 311.555 579.69C322.776 568.469 341.01 568.464 352.225 579.679C363.44 590.894 363.435 609.128 352.214 620.349C342.755 629.807 328.317 631.303 317.304 624.765L215.058 727.01C282.723 789.318 388.16 787.696 453.86 721.996C521.255 654.6 521.286 545.334 453.928 477.976C386.57 410.618 277.304 410.648 209.908 478.044C144.208 543.744 142.552 649.147 204.894 716.845L307.139 614.6Z",
    fill: "#E6BA01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePageBackground);
export default __webpack_public_path__ + "static/media/welcome_page_background.866ce39af6a328dd2e6c26e3d3d46d34.svg";
export { ForwardRef as ReactComponent };